/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactSettingsResponseData,
  GetContactSettingsResponseDataFromJSON,
  GetContactSettingsResponseDataFromJSONTyped,
  GetContactSettingsResponseDataToJSON
} from './GetContactSettingsResponseData'

/**
 *
 * @export
 * @interface UpdateSortContactSettingsResponse
 */
export interface UpdateSortContactSettingsResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateSortContactSettingsResponse
   */
  status?: number
  /**
   *
   * @type {GetContactSettingsResponseData}
   * @memberof UpdateSortContactSettingsResponse
   */
  data?: GetContactSettingsResponseData
}

export function UpdateSortContactSettingsResponseFromJSON(json: any): UpdateSortContactSettingsResponse {
  return UpdateSortContactSettingsResponseFromJSONTyped(json, false)
}

export function UpdateSortContactSettingsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSortContactSettingsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactSettingsResponseDataFromJSON(json['data'])
  }
}

export function UpdateSortContactSettingsResponseToJSON(value?: UpdateSortContactSettingsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactSettingsResponseDataToJSON(value.data)
  }
}
